import { LOCAL_STORAGE_STATE_PERSIST } from '@/utils/constants/checkin.constants';

import initialState from './mutations';

export const getInitialState = () => {
  const savedData = localStorage.getItem(LOCAL_STORAGE_STATE_PERSIST);

  if (savedData) {
    const parsedData = JSON.parse(savedData);

    if (parsedData?.registrationData?.cpf) {
      return parsedData.registrationData;
    }
  }

  return initialState;
};

export const state = getInitialState();
